import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProyectosService } from '../../proyectos.service';
import { comentariosAvances } from 'src/app/shared/model/gestion-proyectos/comentariosAvances';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { nuevosAlcances } from 'src/app/shared/model/gestion-proyectos/nuevosAlcances';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
@Component({
    selector: 'app-modal-comentarios-de-avances',
    standalone: true,
    templateUrl: './modal-comentarios-de-avances.component.html',
    styleUrls: ['./modal-comentarios-de-avances.component.css'],
    imports: [
      FormsModule,
      ReactiveFormsModule,
      CommonModule,
      MatFormFieldModule,
      MatIconModule,
      MatDatepickerModule,
      MatDividerModule
    ],
})
export class ModalComentariosDeAvancesComponent {
  comentariosAvances: Array<comentariosAvances>;
  proyecto: Proyecto;

  constructor(
    public dialogRef: MatDialogRef<ModalComentariosDeAvancesComponent>,
    private dialog: MatDialog,
    private proyectoService: ProyectosService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  
  ngOnInit() {
    if (this.data.id !== null && this.data.id !== undefined) {
      this.proyecto = new Proyecto();
      this.proyecto.idProyecto = this.data.idProyecto;
    } else {
      this.proyecto = this.data as Proyecto;
      
    }
  
  }


  onNoClick(): void {
    this.dialogRef.close();
  }
  }